// dependecies import ==>
import React, { useState } from "react";
// assets and scss import ==>
import "./customChip.scss";
import closeIconGrey from "../../../../assets/closeIconGrey.svg";
import { CUSTOM_BUTTON_STATUS } from "../../ERXConstants/constants";
import loaderIcon from "../../../../assets/loader_check_206d4a52 (1).gif";
import errorIcon from "../../../../assets/cross-error.svg";
import tick from "../../../../assets/tick1.svg";
import Done from "../../../../assets/Done-erx.svg";
import Edit from "../../../../assets/edit-prescription.svg";
import Popover from "react-popover";
import { Divider } from "@material-ui/core";

const CustomChip = (props) => {
  const {
    value,
    showEditBtn,
    hasCustomSaveButton,
    buttonStatus,
    hideDeleteIcon,
    handleSaveChip,
    handleEditChip,
    handleDeleteChip,
  } = props;
  const [open, setOpen] = useState(false);

  const handlePopoverOpen = (e) => {
    setOpen(true);
  };

  const handlePopoverClose = (e) => {
    setOpen(false);
  };

  // Display UI ===>
  const displayCustomChip = () => {
    return (
      <div className="custom-chip-cont">
        {hasCustomSaveButton && (
          <>
            {buttonStatus === CUSTOM_BUTTON_STATUS.SUCCESS && (
              <img
                src={tick}
                alt=""
                style={{ marginRight: "5px", width: "18px", height: "18px" }}
              />
            )}
            {buttonStatus === CUSTOM_BUTTON_STATUS.LOADING && (
              <img
                src={loaderIcon}
                alt=""
                style={{ marginRight: "5px", width: "21px", height: "21px" }}
              />
            )}
            {buttonStatus === CUSTOM_BUTTON_STATUS.ERROR && (
              <img
                src={errorIcon}
                alt=""
                style={{ marginRight: "5px", width: "22px", height: "22px" }}
              />
            )}{" "}
          </>
        )}
        <div className="custim-chip-value">{value}</div>
        {!hideDeleteIcon && (
          <img
            src={closeIconGrey}
            alt=""
            onClick={handleDeleteChip}
            className="custom-chip-delete-icon"
          />
        )}
      </div>
    );
  };
  // <===

  return (
    <div
      className="custom-chip-container"
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      <Popover
        isOpen={open}
        className="popover-class-custom-chip"
        preferPlace="above"
        place="above"
        offset={-1}
        body={
          <div
            className="custom-chip-cont-save-edit"
            onMouseLeave={handlePopoverClose}
          >
            {showEditBtn && (
              <>
                <div className="custom-chip-edit-btn" onClick={handleEditChip}>
                  <img src={Edit} height={"14.09px"} width={"14.09px"} alt="" />
                </div>
              </>
            )}

            {hasCustomSaveButton &&
              buttonStatus === CUSTOM_BUTTON_STATUS.SAVE &&
              showEditBtn && (
                <Divider
                  style={{
                    margin: "8px 0 8px 0",
                  }}
                  orientation="vertical"
                  flexItem
                />
              )}
            {hasCustomSaveButton &&
              buttonStatus === CUSTOM_BUTTON_STATUS.SAVE && (
                <div className="custom-chip-save-btn" onClick={handleSaveChip}>
                  <DoneLogo />
                </div>
              )}
          </div>
        }
      >
        {displayCustomChip()}
      </Popover>
    </div>
  );
};

function DoneLogo() {
  return (
    <img
      src={Done}
      height={"10px"}
      width={"13px"}
      className="svg-color"
      alt=""
    />
  );
}
export default CustomChip;
